/* ----------------- Helpers --------------- */
import { isWeb } from "@helpers/platform";
import type { OriginalItemTypes } from "@memorang/types/src/session/new-session";

/* ----------------- UI Components --------------- */
import { Box, VideoPlayer, useDevice } from "@memorang/ui";

import AudioPlayerContainer from "../containers/AudioPlayerContainer";
/* ----------------- Child Components --------------- */
import ItemStem from "./ItemStem";

interface Props {
	stem: string;
	itemId: number;
	showTTS?: boolean;
	video?: string;
	audio?: string;
	isSummativeTest?: boolean;
	handleHighlightedTextPress?: () => void;
	instructions?: string;
	showInstructions?: boolean;
	originalItemType?: OriginalItemTypes;
	onFillInBlankChange?: (index: number, value: string) => void;
	fillInBlankValue?: string;
	isAnswered?: boolean;
	fillInBlankValues?: string[];
	isFillInTheBlanks?: boolean;
}
export const StemContainer = ({
	stem,
	itemId,
	showTTS,
	video,
	audio,
	isSummativeTest,
	handleHighlightedTextPress,
	originalItemType,
}: Props) => {
	const { isMobile } = useDevice();

	const shouldShowAudioPlayer =
		audio &&
		(originalItemType === "LISTENING_REPLAY" ||
			originalItemType === "AUDIO_INPUT");

	return (
		<Box paddingHorizontal={isWeb && !isMobile ? 0 : 16} gap={16}>
			{stem && (
				<Box gap={16}>
					<ItemStem
						text={stem}
						isSummativeTest={isSummativeTest}
						itemId={itemId}
						showTTS={showTTS}
						handleHighlightedTextPress={handleHighlightedTextPress}
					/>
					{shouldShowAudioPlayer && audio && (
						<AudioPlayerContainer uri={audio} itemId={itemId} />
					)}
				</Box>
			)}
			{video && (
				<Box style={{ marginBottom: 8 }}>
					<VideoPlayer videoUrl={video} />
				</Box>
			)}
		</Box>
	);
};
